export default __webpack_public_path__ + "static/media/f_md-6.f3814eca.svg";